export default __webpack_public_path__ + "static/media/single-cell.c1020702.png";